import React from 'react';
import { Box, Typography, List, ListItem, ListItemIcon, ListItemText } from '@mui/material';
import { CheckCircleOutline } from '@mui/icons-material';

interface HowToWearThisProps {
  suggestions: string[];
}

const HowToWearThis: React.FC<HowToWearThisProps> = ({ suggestions }) => {
  if (!suggestions || suggestions.length === 0) return null;

  return (
    <Box sx={{ mt: 3 }}>
      <Typography variant="h6" gutterBottom sx={{ fontWeight: 600 }}>How to Wear This</Typography>
      <List dense>
        {suggestions.map((tip, i) => (
          <ListItem key={i} disableGutters>
            <ListItemIcon sx={{ minWidth: 32 }}>
              <CheckCircleOutline color="primary" fontSize="small" />
            </ListItemIcon>
            <ListItemText primary={tip} />
          </ListItem>
        ))}
      </List>
    </Box>
  );
};

export default HowToWearThis;
